import RestService from './RestService'

export default class AttachmentService extends RestService {
    constructor () {
        super( 'attachments' )
    }

    saveAttachment(appId, fieldId, recordId, file) {
        let url = this.baseUrl + '/api/v1/attachments.json?t=' + Date.now()

        let formData = new FormData()
        formData.append('attachment[name]', file.name)
        formData.append('attachment[file]', file)
        formData.append("attachment[file_type]", file.type)
        formData.append('attachment[app_id]', appId)
        formData.append('attachment[field_id]', fieldId)
        formData.append('attachment[record_id]', recordId)


        return new Promise((resolve, reject) => {
            this.http.post(url)
                .send(formData)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        let updatedRecord = JSON.parse(response.text)
                        console.log('Attachment saved')
                        console.log(updatedRecord)
                        resolve(updatedRecord)
                    } else {
                        // this.messageUtil.error(response.statusText)
                        reject(response.statusText)
                    }

                })
        })
    }
}